import { render } from "./EditImgFormFamilyAdminComponent.vue?vue&type=template&id=0a777082&scoped=true"
import script from "./EditImgFormFamilyAdminComponent.vue?vue&type=script&lang=js"
export * from "./EditImgFormFamilyAdminComponent.vue?vue&type=script&lang=js"

import "./EditImgFormFamilyAdminComponent.vue?vue&type=style&index=0&id=0a777082&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a777082"]])

export default __exports__